// extracted by mini-css-extract-plugin
module.exports = {"appContainer":"App_appContainer__14-cH","link":"App_link__1NTxk"};